import { useProjectContext } from 'services/Store/Project/hooks'
import { getSectionId, getProjectId, getCompanyId } from 'services/Store/Project/selectors'

export const useGetElementLink = (blockId: string) => {
  const sectionId = useProjectContext(getSectionId)
  const projectId = useProjectContext(getProjectId)
  const companyIdParams = useProjectContext(getCompanyId)

  //  @ts-expect-error TODO
  const companyId = companyIdParams || window.defaultData?.project?.companyId || ''
  return `https://app.parta.io/#/app/${companyId}/project/${projectId}/preview/${sectionId}/block/${blockId || ''}`
}
